<div [formGroup]="form" *ngIf="field.editable">
  <ng-container *ngIf="!isPercentAttribute">
    <input
      [formControlName]="field.alias"
      [id]="'ba-'+ field.alias"
      mask="separator"
      class="form-control"
      type="text"
      [attr.disabled]="disabled ? '' : null"
    />
  </ng-container>
  <ng-container *ngIf="isPercentAttribute">
    <input
      [formControlName]="field.alias"
      [id]="'ba-'+ field.alias"
      [ngClass]="{'is-invalid':!control.valid && (control.touched || control.dirty)}"
      mask="0||00||000"
      suffix=" %"
      class="form-control"
      type="text"
      [attr.disabled]="disabled ? '' : null"
    />
    <span *ngFor="let errorMessage of errorMessages" class="invalid-feedback">
      {{ errorMessage }}
    </span>
  </ng-container>
</div>
<ng-container *ngIf="!field.editable && field.value">
  <span *ngIf="isPercentAttribute">
    {{ field.value }}%
  </span>
  <span *ngIf="!isPercentAttribute">
    {{ field.value }}
  </span>
</ng-container>
